const RUNTIME_SHIM_SPECIFIER_PATTERN = /^\/__mutiny\/runtime\/([\w-]+)\/([\w.-]+)\.js$/;

// Resolve a compiled artifact's `/__mutiny/runtime/<slug>/<v>.js` import (react and the
// diagram/animation libraries) to the matching shim on the same static CDN as the bundle, avoiding a
// cross-origin hop to champaign's version-gated route. The slug/version are taken verbatim from the
// specifier the compiler baked in — a real artifact only ever carries registry-allowlisted slugs, so
// this stays a pure string transform; an unknown slug just 404s at the CDN. `staticAssetsBaseURL` is
// nullable to match the sibling resolveCompiledUrl call sites.
export function buildRuntimeShimUrl(staticAssetsBaseURL: string | null, specifier: string): string {
  const match = specifier.match(RUNTIME_SHIM_SPECIFIER_PATTERN);
  if (!match) {
    throw new Error(`Unsupported custom-component runtime specifier: ${specifier}`);
  }
  const [, slug, version] = match;
  return `https://${staticAssetsBaseURL}/assets/mutiny-runtime-${slug}-${version}.js`;
}
